export enum HrObjectType {
	'Users',
	'Positions',
	'Department',
	'Professions',
	'Groups',
	'PropertyTypes',
	'ManagerKeys'
}
